import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { css } from '@emotion/react';
export const StyledDetailsSectionTextPrimary = styled(Typography)`
  color: #6d6d6d;
  font-weight: 700;
  font-size: 14px;
  ${(props) =>
    props.sx &&
    css`
      ${props.sx}
    `}
`;
